export default __webpack_public_path__ + "static/media/firwal.1fefa9a6.png";